export default "__VITE_ASSET__7910148c__"